export interface Review {
  id: number;
  username: string;
  role: string;
  content: string;
  headline: string;
  rating: number;
}

export const reviews: Review[] = [
  {
    id: 1,
    username: '吃瓜不嫌事大',
    role: '资深用户 · 3年吃瓜',
    content: '51黑料真的是我每天必刷的吃瓜平台！信息更新速度超级快，而且很多独家爆料在其他地方根本看不到。上次那个顶流塌房的料，我在这里第一时间就看到了，比微博早了整整一天！',
    headline: '信息快人一步，吃瓜必备',
    rating: 5,
  },
  {
    id: 2,
    username: '娱乐圈观察家',
    role: '自媒体人 · 粉丝12万',
    content: '作为一个自媒体从业者，51黑料的爆料准确率让我非常惊讶。很多看起来离谱的瓜最后都被证实是真的，而且他们还有独家验证体系，不是随便什么料都发的。',
    headline: '爆料准确率高，值得信赖',
    rating: 5,
  },
  {
    id: 3,
    username: '深夜吃瓜人',
    role: '忠实用户 · 连续签到200天',
    content: '每天睡前必刷51黑料的每日黑料大赛，看看今天又有哪些新瓜。有时候刷到停不下来，从十点刷到凌晨两点。质量比起其他吃瓜号高出不止一个档次！',
    headline: '每日更新，内容质量高',
    rating: 5,
  },
  {
    id: 4,
    username: '瓜田里的守望者',
    role: '认证用户 · 贡献12条爆料',
    content: '最让我喜欢的是他们的匿名投稿机制，我投过几次料都很快被核实发布了。保护投稿人隐私做得很好，让人敢说真话。平台的验证流程也让人觉得靠谱。',
    headline: '匿名投稿安全可靠',
    rating: 4,
  },
  {
    id: 5,
    username: '理性吃瓜群众',
    role: '专栏作者 · 独立撰稿人',
    content: '51黑料和其他吃瓜号最大的不同在于他们有态度、有底线。不是为黑而黑，每条爆料都有事实核查。而且界面设计很清爽，阅读体验特别好，没有那种乱七八糟的弹窗广告。',
    headline: '有底线有态度，行业清流',
    rating: 5,
  },
  {
    id: 6,
    username: '八卦雷达全开',
    role: 'VIP用户 · 会员2年',
    content: '页面加载速度很快，视频播放也很流畅。分类也很清晰，想看明星八卦还是网红爆料一目了然。希望继续加油，做出更多独家内容！黑料大赛的互动性也特别强。',
    headline: '体验流畅，分类清晰',
    rating: 4,
  },
];